// extracted by mini-css-extract-plugin
export default {"productdiv":"ProductCharacteristics_productdiv__GmEMG","addmoreleg":"ProductCharacteristics_addmoreleg__-zay5","delete_box":"ProductCharacteristics_delete_box__Ofhut"};